import Vue from 'vue'
import axios from 'axios'
import Vant, {Dialog, Toast} from 'vant'
import 'vant/lib/index.css'
import 'styles/iconfont1.css'
import 'styles/iconfont.css'
import 'styles/index.css'
import './isMobile.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import VueParticles from 'vue-particles'
import md5 from 'js-md5'
import ElementUI,{ Message, confirm, loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueAMap from 'vue-amap'

axios.defaults.withCredentials = true
Vue.prototype.$axios = axios
Vue.prototype.$md5 = md5
Vue.prototype.$Message = Message
Vue.prototype.$confirm = confirm
Vue.prototype.$loading = loading
Vue.use(VueAwesomeSwiper)
Vue.use(VueParticles)
Vue.use(ElementUI)
Vue.use(Vant)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'ee69817529659ec9420f072183621d26',
  plugin: ['AMap.Container', 'AMap.Parameters']
});

// 在请求头中加token
axios.interceptors.request.use(
  config => {
    var login // 必须登录接口添加 login = 1 参数
    var type // 添加类型，1 为 供应链（设置跳转登录页）
    var token
    var Jump // 设置跳转登录页
    if (config.method === 'get') {
      login = config.login
      type = config.LoginType
    } else {
      login = config.data.login
      type = config.data.LoginType
    }
    if (type === 1) {
      token = sessionStorage.getItem('GylToken')
      Jump = 'gylLogin.html'
    } else if (type === 2) {
      token = sessionStorage.getItem('GiftToken')
      Jump = 'giftLogin.html'
    }
    if (!config.headers.hasOwnProperty('token') && token) {
      config.headers.Authorization = token
    }
    config.headers.JumpT = Jump
    if (login === 1) {
      if (!token || token === '') {
        setTimeout(function () {
          location.href = Jump
          config.headers.loginT = 1
        }, 2000)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(res => {
  if (res.config.responseType !== 'blob') {
    if (res.data.code === 444) {
      Dialog.confirm({
        title: '请先登录',
        message: '请先登录才可使用该功能，如果没有账号可注册',
        confirmButtonText: '取消',
        cancelButtonText: '登录',
        closeOnClickOverlay: true
      }).then(() => {
        location.href = 'gift.html'
      }).catch(() => {
        location.href = res.config.headers.JumpT
      })
      
    } else if (res.data.code !== 200) {
      Toast(res.data.message)
    } else {
      return res
    }
  } else {
    return res
  }
})

Vue.prototype.resetSetItem = function (key, newVal) {
  // if (key === 'GiftIslogin') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  // }
}


// WEBPACK FOOTER //
// ./src/util/appUtil.js